// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const magcargo: PokeData = {
  "id": 219,
  "name": "magcargo",
  "height": 8,
  "weight": 550,
  "base_experience": 151,
  "types": [
    PokeType.FIRE,
    PokeType.ROCK
  ],
  "api_moves": [
    "body-slam",
    "ember",
    "flamethrower",
    "rock-throw",
    "recover",
    "harden",
    "smog",
    "amnesia",
    "rock-slide",
    "ancient-power",
    "yawn",
    "earth-power",
    "lava-plume",
    "flame-burst",
    "clear-smog",
    "shell-smash",
    "incinerate"
  ],
  "moves": [
    "body-slam",
    "ember",
    "flamethrower",
    "rock-throw",
    "rock-slide",
    "ancient-power",
    "earth-power",
    "magma-storm",
    "boulder_bash",
    "stone-axe",
    "stone-crush",
    "fire-spin",
    "rock-blast"
  ],
  "evolution_chain": {
    "id": 111,
    "item": null,
    "species": [
      {
        "name": "slugma",
        "order": 249,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "magcargo",
        "order": 250,
        "types": [
          PokeType.FIRE,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 218,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 160,
    "speed": 60,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
